/* eslint-disable no-shadow */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import routes from '../../../config/routes'
import * as reducks from '../../../reducks'
import { formatToBR } from '../../../utils/date'
import Equalizer from '../../commons/Icons/Equalizer'
import BoxRounded from '../../commons/BoxRounded/BoxRounded'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Text from '../../commons/Text/Text'
import IndicatorManagerial from '../../commons/indicatorManagerial/IndicatorManagerial'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import ExtractDetailThree from '../ExtractDetailThree/ExtractDetailThree'
import styles from './extractDetailTwo.module.scss'

const ExtractDetailTwo = (props) => {
  const { match: { params: { storeTabNumber, id } = {} } = {} } = props

  const dispatch = useDispatch()

  const { getExtractLeveTwo, getExtractLevelThree } =
    reducks.resources.extract.actions

  useEffect(() => {
    dispatch(getExtractLeveTwo(storeTabNumber, id))
  }, [])

  const {
    extractLevelTwo,
    currentExtract = {},
    extract,
    fetching
  } = useSelector((state) => state.extractReducer)

  const { store: { nameFantasy } = {} } = extract

  const { currentValue, indicator, name } = currentExtract

  const breadcrumbs = [
    {
      id: 1,
      title: 'Carteira',
      path: routes.wallet.path
    },
    {
      id: 2,
      title: nameFantasy,
      path: routes.extract.generate(storeTabNumber)
    },
    {
      id: 3,
      title: 'Indicadores gerenciais'
    }
  ]

  function showModalLevelThree(storeTabNumber, id, item) {
    dispatch(getExtractLevelThree(storeTabNumber, id, item.indentifier))
  }

  return (
    <DefaultLayout>
      <ExtractDetailThree />
      <Flex column flex="1">
        {indicator && (
          <>
            <Text color="gray" size="lg" variation="dark" bold>
              Dados de {indicator?.subtitle}
            </Text>
            <Breadcrumb items={breadcrumbs} />
            <Flex alignItems="center">
              <BoxRounded width="70%" height="160px">
                <Flex column>
                  <Text
                    color="gray"
                    variation="dark"
                    extraBold
                    size="lg"
                    margin="18px 0px"
                  >
                    {indicator?.title}
                  </Text>
                  <Text
                    color="gray"
                    font="custom"
                    size="sm"
                    margin="0px 0px 20px 0px"
                  >
                    {`${indicator?.periodicityName}, ${formatToBR(
                      indicator?.updatedAt
                    )}`}
                  </Text>
                </Flex>
              </BoxRounded>
              <BoxRounded darkGradient width="30%" height="160px">
                <Flex alignItems="center" justifyContent="space-between">
                  <Flex column>
                    <Text
                      font="custom"
                      extraBold
                      size="mlg"
                      color="gray"
                      variation="lightest"
                      margin="15px 0px"
                    >
                      {name}
                    </Text>
                    <Flex alignItems="center">
                      {!!currentValue.prefix && (
                        <Text
                          font="custom"
                          color="white"
                          variation="light"
                          size="sm"
                          fontWeight="400"
                          margin="0px 10px 0px 0px"
                        >
                          {currentValue.prefix}
                        </Text>
                      )}
                      {currentValue.formatted && (
                        <Text
                          font="custom"
                          color="white"
                          variation="light"
                          size="sm"
                          fontWeight="400"
                        >
                          {currentValue.formatted}
                        </Text>
                      )}
                      {!!currentValue.sufix && (
                        <Text
                          font="custom"
                          color="white"
                          variation="light"
                          size="sm"
                          fontWeight="400"
                          margin="0px 10px 0px 0px"
                        >
                          {currentValue.sufix}
                        </Text>
                      )}
                    </Flex>
                  </Flex>
                  <Equalizer />
                </Flex>
              </BoxRounded>
            </Flex>
          </>
        )}

        {extractLevelTwo?.length > 0 && (
          <div className={styles.grid}>
            {extractLevelTwo.map((item) => (
              <IndicatorManagerial
                key={item.identifier}
                title={item.name}
                updatedAt={item.referenceAt}
                current={item.value}
                previous={item.valuePenult}
                minimum={item.valueMinimum}
                formatId={item.formatId}
                periodicityName={item?.periodicityName}
                margin="0 20px 20px 0"
                seeMoreClick={
                  item.hasDetails
                    ? showModalLevelThree(storeTabNumber, id, item)
                    : null
                }
              />
            ))}
          </div>
        )}
        {fetching && (
          <div className={styles.center}>
            <LoadingBounce />
          </div>
        )}
      </Flex>
    </DefaultLayout>
  )
}

ExtractDetailTwo.defaultProps = {
  match: {}
}

ExtractDetailTwo.propTypes = {
  match: PropTypes.shape({})
}

export default ExtractDetailTwo
